var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgQbr28 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 12L11.1226 15.4549H14.7553L11.8164 17.5902L12.9389 21.0451L10 18.9098L7.06107 21.0451L8.18364 17.5902L5.24472 15.4549H8.87743L10 12Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 2H10V6H12V4H24V18H20V20H26V2Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 26V8H2V26H18ZM4 24V10H16V24H4Z",
    fill: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgQbr28);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;